/* eslint-disable no-param-reassign */
import axios from 'axios';
import qs from 'qs';

class ServiceBase {
  constructor({ resource, baseURL = process.env.BASE_URL }) {
    this.resource = `${resource}/`;
    this.http = axios.create({
      baseURL,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    });

    this.http.interceptors.request.use((config) => {
      const token = localStorage.getItem('token');
      const applicationId = process.env.APPLICATION_ID;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      if (applicationId) {
        config.headers.Application = `Bifrost ${applicationId}`;
      }
      return config;
    });
  }

  getUrl = (id) => {
    const url = `${this.resource}${id}/`;
    return url;
  }

  create = (data) => {
    const response = this.http.post(this.resource, data);
    return response;
  }

  getList = (params) => {
    const response = this.http.get(this.resource, params = { params });
    return response;
  }

  get = (id) => {
    const response = this.http.get(this.getUrl(id));
    return response;
  }

  update = (id, data) => {
    const response = this.http.put(this.getUrl(id), data);
    return response;
  }

  getInstanceAction = (id, action, params = {}) => this.http.get(`${this.getUrl(id)}${action}/`, { params });

  getResourceAction = (action, params = {}) => this.http.get(`${this.resource}${action}/`, params);

  postResourceAction = (action, data = {}) => this.http.post(`${this.resource}${action}/`, data);
}

export default ServiceBase;



// WEBPACK FOOTER //
// ./src/services/ServiceBase.js